import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { cn } from '@/lib/utils';
export default function AnimatedSection({ children, className, id, fullHeight = true, }) {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: '-10%' });
    return (<motion.section id={id} ref={ref} initial={{ opacity: 0, y: 20 }} animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }} transition={{ duration: 0.8 }} className={cn(fullHeight ? 'min-h-screen' : '', className)}>
      {children}
    </motion.section>);
}
